import { Injectable } from '@angular/core';
import { RubricApi } from 'src/app/api/observations/rubric/rubric.api';
import { RubricCreateDTO } from 'src/app/model/observation/rubric/rubric-create-dto.model';
import { RubricSaveDTO } from 'src/app/model/observation/rubric/rubric-save-dto.model';

@Injectable()
export class RubricService {

    constructor(private rubricApi: RubricApi) { }

    getRubric = (rubricId: string) => this.rubricApi.getRubric(rubricId);

    createRubric = (createRubricDTO: RubricCreateDTO) => this.rubricApi.createRubric(createRubricDTO);
    
    saveRubric = (rubricSaveDTO: RubricSaveDTO) => this.rubricApi.saveRubric(rubricSaveDTO);

    submitRubric = (rubricSaveDTO: RubricSaveDTO) => this.rubricApi.submitRubric(rubricSaveDTO);
}